export const EntryPointBannerTypes = {
  PPO: 'ppo',
  PPO_WITH_PROMO: 'ppo_with_promo',
  MEMBER_UPGRADE: 'member_upgrade',
  MEMBER_UPGRADE_WITH_PROMO: 'member_upgrade_with_promo',
  MEMBER_EARLY_RENEWAL: 'early_renewal',
}

export const EntryPointBannerTracking = {
  MESSAGE_GOAL: 'Membership GHP Entry Points',
  DISPLAY_SUBLOCATION: {
    GLOBAL_HOME: 'global_home',
    HAMBURGER_MENU: 'hamburger_menu',
  },
  content: {
    BANNER: EntryPointBannerTypes,
    HAMBURGER_MENU: {
      SHIPT_MEMBERSHIP: 'shipt_membership',
      GET_SHIPT_MEMBERSHIP: 'get_shipt_membership',
    },
  },
  type: {
    BANNER: 'banner',
    BUTTON: 'button',
  },
}
